<template>
  <div class="main">
    <div class="mask" v-show="maskShow" @click="maskShow = false">
      <img src="@/assets/img/zhixiang.png" alt="">
    </div>
    <img src="@/assets/img/w2.png" alt="" />
    <div class="btn" @click="download">立即下载</div>
    <img src="@/assets/img/w3.png" alt="" />
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      maskShow: false,
      href: "",
    };
  },
  mounted() {
    this.getDownload()
  },
  methods: {
    getDownload() {
      this.$request.get("erpService/yw/api/app/version/simple.do?appType=Android&versionNum=0.0.0")
        .then((res) => {
          if (res.success) {
            this.href = res.result.apkUrl
            this.$toast(res.message);
          } else {
            this.$toast(res.message);
          }
        });
    },
    download() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // this.$toast("请使用默认浏览器打开");
        this.maskShow = true
      } else {
        window.location.href = this.href
        // if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        //   this.$new
        //     .post(
        //       "/itemInfo/addAppDown.do",
        //       qs.stringify({
        //         type: 1,
        //       })
        //     )
        //     .then((res) => {
        //       window.location.href = "http://itunes.apple.com/app/id1548226667";
        //     });
        // }
        // if (navigator.userAgent.match(/android/i)) {
        //   this.$new
        //     .post(
        //       "/itemInfo/addAppDown.do",
        //       qs.stringify({
        //         type: 0,
        //       })
        //     )
        //     .then((res) => {
        //       window.location.href =
        //         "https://www.xzhouse.com.cn/page/generation/xzhouse.apk"; // 下载地址
        //     });
        // }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  img {
    position: absolute;
    right: 0;
    top: 0.5rem;
    width: 70%;
  }
}

img {
  display: block;
  width: 100%;
}

.btn {
  margin: 0.4rem auto;
  width: 6.2rem;
  line-height: 0.88rem;
  border-radius: 0.44rem;
  color: #fff;
  background-color: #3072f5;
  text-align: center;
  font-size: 0.3rem;
  cursor: pointer;
}

p {
  color: #999;
  font-size: 0.28rem;
  text-align: center;
  margin-bottom: 0.2rem;
  cursor: pointer;
}
</style>